import { PersistStorage } from 'zustand/middleware';

// Timed local storage wrapper with Base64 encoding/decoding
export const timedLocalStorage = (expiryTime: number): PersistStorage<any> => {
	// Encode to Base64
	function encodeBase64(data: string) {
		return btoa(data);
	}

	// Decode from Base64
	function decodeBase64(data: string) {
		return atob(data);
	}
	return {
		getItem: (name) => {
			const item = localStorage.getItem(name);
			if (!item) return null;

			const decodedItem = decodeBase64(item);

			const parsed = JSON.parse(decodedItem);
			const now = new Date().getTime();
			if (now - parsed.timestamp > expiryTime) {
				localStorage.removeItem(name);
				return null;
			}
			return parsed.value;
		},
		setItem: (name, value) => {
			const now = new Date().getTime();
			const encodedValue = encodeBase64(JSON.stringify({ value, timestamp: now }));
			localStorage.setItem(name, encodedValue);
		},
		removeItem: (name) => {
			localStorage.removeItem(name);
		},
	};
};
